import omitDeep from 'omit-deep-lodash';

export const omitTypename = <T extends object>(obj: T) =>
  omitDeep(obj, '__typename') as T;
